module.exports = __webpack_public_path__ + "img/img-administrator.c5649eb1.svg";